import { ReactElement } from 'react';
import { FieldProps } from '@frontend/design-system';

export type DayToSend = 'sunday' | 'monday' | 'tuesday' | 'wednesday' | 'thursday' | 'friday' | 'saturday';

export enum SendType {
  SendAll = 'send-all',
  SendSpecific = 'send-specific',
}

export type Step = {
  id: StepId;
  Component: ReactElement;
  collapsedValue: ReactElement;
  readValue?: ReactElement;
  hide?: boolean;
};

export type StepId = 'title' | 'locations' | 'when-to-send' | 'content' | 'audience' | 'attachments';

export type AttachmentFieldProps = FieldProps<
  {
    attachments: {
      type: 'multiselect';
    };
  },
  'attachments'
>;
export type DateFieldProps = FieldProps<
  {
    date: {
      type: 'date';
    };
  },
  'date'
>;

export type DaysToSendFieldProps = FieldProps<
  {
    daysToSend: {
      type: 'checklist';
    };
  },
  'daysToSend'
>;

export type LocationIdsFieldProps = FieldProps<
  {
    locationIds: {
      type: 'checklist';
    };
  },
  'locationIds'
>;
export type TimeFieldProps = FieldProps<
  {
    time: {
      type: 'time';
    };
  },
  'time'
>;
